module.exports = __webpack_public_path__ + "dbe14a665dc6bf73e15f582038c99aa6.png";